/**
 * Route for `audit-trail-security-compliance-log`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AuditTrailSecurityComplianceLogPage } from "../features/audit-trail-security-compliance-log/AuditTrailSecurityComplianceLogPage";

export const auditTrailSecurityComplianceLogRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/audit-trail-security-compliance-log",
	component: AuditTrailSecurityComplianceLogPage,
});

export default auditTrailSecurityComplianceLogRoute;
